import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const rdiv = document.getElementById('activia_ght');
const root = ReactDOM.createRoot(rdiv);

const isLogged = rdiv.getAttribute('data-logged') === 'true';
const postId = rdiv.getAttribute('data-post-id');
const wpNonce = rdiv.getAttribute('data-wp-nonce');
const odr = rdiv.getAttribute('data-odr');
const mailTemplate = rdiv.getAttribute('data-mail-template');
const sourceConversion = rdiv.getAttribute('data-source-conversion');


root.render(
  <React.StrictMode>
    <App isLogged={isLogged} postId={postId} wpNonce={wpNonce} odr={odr} mailTemplate={mailTemplate} sourceConversion={sourceConversion} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
